// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__gJ_qv","layer":"banner_layer__RDaGv"};